export const daysPicker = {
  next: 'Next',
  previous: 'Previous',
}
